import Vue from 'vue'
import Router from 'vue-router'
import { Notification } from 'element-ui';
// import Home from './views/Home.vue'

Vue.use(Router)


const router = new Router({
  routes: [
    {
      path:'/',
      name:'login',
      component:()=> import('./page/login.vue'),
      meta: {
        title: '识字小程序后台管理系统登陆页面'
     }
    },
    // {
    //   path: '/',
    //   name: 'home',
    //   component: Home
    // },
    {
      path: '/home',
      name: 'home',
      meta: { re:true },
      redirect: '首页',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './page/home.vue'),
      children:[
        {
          path:'/首页',
          name:'首页',
          meta: { re:true,title:'识字小程序后台首页' },
          component:() => import('./page/first.vue'),
      
        },
        {
          path:'/单词成绩',
          name:'单词成绩',
          meta: { re:true ,ter:true,title:'单词成绩'},
          component:() => import('./page/achievement.vue'),
          children:[{
            path:'/单词成绩查看',
            name:'单词成绩查看',
            meta: { re:true,ter:true,title:'单词成绩查看' },
            component:() => import('./page/achievement.vue'),
          }]
        },
        {
          path:'/文章成绩',
          name:'文章成绩',
          meta: { re:true,ter:true ,title:'文章成绩'},
          component:() => import('./page/achievement.vue'),
          children:[{
            path:'/文章成绩查看',
            name:'文章成绩查看',
            meta: { re:true ,ter:true,title:'文章成绩查看'},
            component:() => import('./page/achievement.vue')
          }]
        },
        {
          path:'/词库管理',
          name:'词库管理',
          meta: { re:true,title:'词库管理' },
          component:() => import('./page/word/word.vue'),
        },
        {
          path:'/词库查看',
          name:'词库查看',
          meta: { re:true ,title:'词库管理查看'},
          component:() => import('./page/word/wordWatch.vue'),
        },
        {
          path:'/文章管理',
          name:'文章管理',
          meta: { re:true,title:'文章管理' },
          component:() => import('./page/article/article.vue'),
          
          
          
        },
        {
          path:'/文章查看',
          name:'文章查看',
          meta: { re:true ,title:'文章查看'},
          component:() => import('./page/article/articleWatch.vue'),
        },
        {
          path:'/文章查看修改',
          name:'文章查看修改',
          meta: { re:true ,title:'文章查看修改' },
          component:() => import('./page/article/change.vue'),
        },
        {
          path:'/启动页管理',
          name:'启动页管理',
          meta: { re:true,  title:'启动页管理'},
          component:() => import('./page/management.vue'),
          children:[
            {
              path:'/启动页查看',
              name:'启动页查看',
              meta: { re:true  ,title:'启动页查看'},
              component:() => import('./page/management.vue'),
            }
          ]
        },
        {
          path:'/作文题目发放',
          name:'作文题目发放',
          meta: { re:true,ter:true  ,title:'作文题目发放'},
          component:() => import('./page/management.vue'),
          children:[
            {
              path:'/作文查看',
              name:'作文查看',
              meta: { re:true ,ter:true ,title:'作文查看'},
              component:() => import('./page/management.vue'),
            }
          ]
        },
        {
          path:'/优秀作文展示',
          name:'优秀作文展示',
          meta: { re:true ,ter:true,title:'优秀作文展示'},
          component:() => import('./page/management.vue'),
          children:[
            {
              path:'/优秀作文查看',
              name:'优秀作文查看',
              meta: { re:true,ter:true ,title:'优秀作文查看' },
              component:() => import('./page/management.vue'),
            }
          ]
        },
        {
          path:'/学生信息查看',
          name:'学生信息查看',
          meta: { re:true,ter:true ,title:'学生信息查看'},
          component:() => import('./page/students.vue')
        },
        {
          path:'/学生查看',
          name:'学生查看',
          meta: { re:true,ter:true ,title:'学生查看' },
          component:() => import('./page/students.vue')
        },
        {
          path:'/游戏价格设置',
          name:'游戏价格设置',
          meta: { re:true,ter:true ,title:'游戏价格设置' },
          component:() => import('./page/priceConfig.vue')
        }
      ]
      
    }

  ]
})
// if () {
 
// } else {
//   this.token = JSON.parse(window.sessionStorage.getItem('token')).token
//   console.log('router',token)
// }
// let token= ''

router.beforeEach((to, from, next) => {
  if (to.meta.re) {
    console.log(sessionStorage.getItem('token'))
    if (!JSON.parse(sessionStorage.getItem('token')) && typeof(JSON.parse(sessionStorage.getItem('token')))!='undefined' && JSON.parse(sessionStorage.getItem('token'))!=0) {
          next('/')
          Notification({message:'请登陆',type:'error'}) 
    }else{
      console.log('走到这里')
      console.log(to.meta.ter === undefined )
      if (to.meta.ter === undefined && JSON.parse( sessionStorage.getItem('role')).role === 'teacher') {
        next('/')
        Notification({message:'请用管理员账号登陆',type:'error'}) 
      }else{
        console.log('走到这里111')
        next()
      }
     
    }
  }else {
    next()
  }
})
export default router